// New UI for Vendor Mapping (docs/ui_redesign/16-vendor-mapping-and-dashboard-concepts.md, "Vendor Mapping", option B).
// Display only: VendorMapDetailDialog, VendorInformation and MappedInvoiceFields keep their state, handlers and checks.

// The row layout the classic sub-sections (Invoice details, Broadcast media fields) get in the new UI: label, the
// scanned-key dropdown, then the value, all left aligned, lined up with the mapping table's columns.
export const VM_STYLE = {
	cellOneStyle: { textAlign: 'left' },
	cellTwoStyle: {},
	cellThreeStyle: {},
	mainRowStyle: { paddingBottom: '4px', paddingLeft: '0px', paddingRight: '0px' },
	mainRowSpacing: 1,
	cellOneWidth: 3,
	cellTwoWidth: 4,
	cellThreeWidth: 5,
	inputStyle: {}
};

const MODULE = { 1: 'Media', 2: 'Production', 3: 'Broadcast' };
const fileName = loc => String(loc || '').split(/[\\/]/).pop();

// The header: which module, the identifier being mapped, whether the mapping is new or saved, and the invoice it
// comes from.
export function vmHeaderInfo(info = {}, documentVendorMapping, vendorIdentifier) {
	const doc = info.invoiceDocument || {};
	const mode = info.mode;
	const saved = documentVendorMapping && documentVendorMapping.detailflag != null;
	const state = mode === 'View' ? 'View only' : mode === 'Copy' ? 'Copy' : saved ? 'Saved mapping' : 'New mapping';
	const file = doc.fileName || doc.invoiceDocumentFileName || fileName(doc.invoiceDocumentFileLocation);
	const status = doc.status ? `${doc.status}${doc.invoiceDocumentStatusId ? ` (${doc.invoiceDocumentStatusId})` : ''}` : '';
	return {
		eyebrow: `${MODULE[Number(info.modelDefId)] || 'Invoices'} · Vendor mapping`,
		title: vendorIdentifier || doc.vendorIdentifier || 'Vendor mapping',
		state,
		tone: mode === 'View' ? '' : saved ? 't-ok' : 't-info',
		meta: [file, doc.invoiceNumber, status].filter(Boolean).join(' · ')
	};
}

// What the Check column says about a mapped field. v: { displayValue, isValid }; mappedField: the scanned key.
export function fieldCheck(field, v, mappedField) {
	if (field === 'invoiceCurrency') return v.displayValue ? { tone: 'calc', text: 'From the vendor' } : { tone: 'mut', text: 'Choose a vendor' };
	if (!v.displayValue) return { tone: 'mut', text: 'Not found' };
	if (!v.isValid) return { tone: 'warn', text: 'Check format' };
	if (field === 'dueDate' && !mappedField) return { tone: 'calc', text: 'From payment term' };
	return { tone: 'ok', text: 'Found' };
}

// R10: Vendor Mapping Results as one line per company: created, created with what is missing, or already mapped.
// The same wording VendorMapDetailDialog builds; only the layout and colours change.
export function mappingResultLines(result, companies = []) {
	const lines = [];
	((result && result.success) || []).forEach(name => {
		const company = companies.find(c => c.coName === name);
		const match = ((result && result.transferredResults) || []).find(r => company && r.companyCode === company.companyCode);
		const missing = [match && match.paymentTermsMessage && 'Payment Term', match && match.taxCodeMessage && 'Tax Code', match && match.userStatusMessage && 'User Status'].filter(Boolean);
		lines.push(missing.length
			? { tone: 'warn', text: `Vendor mapping created with warning: ${missing.join(', ')} missing in ${name}` }
			: { tone: 'ok', text: `Vendor mapping created in ${name}` });
	});
	((result && result.failure) || []).forEach(name => lines.push({ tone: 'bad', text: `Vendor mapping already exists for ${name}.` }));
	return lines;
}
